import React from "react";

const NotificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-labelledby="a8yy45m8edi7lw9dnbiuorpnfthxkj96"
      className="fill-current text-white opacity-75 hover:text-white mx-3"
    >
      <title id="a8yy45m8edi7lw9dnbiuorpnfthxkj96">Notifications</title>
      <path d="M20 17h2v2H2v-2h2v-7a8 8 0 1116 0v7zm-2 0v-7a6 6 0 10-12 0v7h12zm-9 4h6v2H9v-2z"></path>
    </svg>
  );
};

export default NotificationIcon;
